import React, { useState, useEffect } from 'react';
import Wall from './components/Wall';
import FormOverlay from './components/FormOverlay';
import ThemeToggle from './components/ThemeToggle';
import QROverlay from './components/QROverlay';

export default function App() {
  const [theme, setTheme] = useState('dark');
  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState('');
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showQR, setShowQR] = useState(() => new URLSearchParams(window.location.search).has('qr'));

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  const handleSubmitSuccess = () => {
    const messages = [
      'Thanks for making UB what it is 🩵',
      'Thanks for being part of the UB community 🩵',
    ];
    setConfirmMsg(messages[Math.floor(Math.random() * messages.length)]);
    setSubmitted(true);
    setRefreshTrigger(t => t + 1);
    setTimeout(() => {
      setShowForm(false);
      setSubmitted(false);
    }, 3000);
  };

  const handleSkip = () => {
    setShowForm(false);
  };

  const handleAddMemory = () => {
    setSubmitted(false);
    setShowForm(true);
  };

  const isDark = theme === 'dark';

  const styles = {
    app: {
      position: 'relative',
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      background: isDark ? '#000' : '#fff',
    },
    addButton: {
      position: 'fixed',
      bottom: '2rem',
      right: '2rem',
      background: '#00C4C8',
      color: '#000',
      border: 'none',
      borderRadius: '50%',
      width: '3.25rem',
      height: '3.25rem',
      fontSize: '1.75rem',
      lineHeight: 1,
      cursor: 'pointer',
      zIndex: 10,
      transition: 'opacity 0.2s',
    },
  };

  return (
    <div style={styles.app}>
      <ThemeToggle theme={theme} setTheme={setTheme} />
      <Wall refreshTrigger={refreshTrigger} theme={theme} />
      {showForm && (
        <FormOverlay
          theme={theme}
          submitted={submitted}
          confirmMsg={confirmMsg}
          onSubmitSuccess={handleSubmitSuccess}
          onSkip={handleSkip}
        />
      )}
      {!showForm && (
        <button
          style={styles.addButton}
          onClick={handleAddMemory}
          onMouseEnter={e => (e.target.style.opacity = '0.85')}
          onMouseLeave={e => (e.target.style.opacity = '1')}
        >
          +
        </button>
      )}
      <QROverlay theme={theme} show={showQR} onToggle={() => setShowQR(q => !q)} />
    </div>
  );
}
